export default "__VITE_ASSET__DwfRbCY2__"